export const onSvgHover = (ref) => {
    if (!ref?.current) return;
    ref.current.setAttribute('fill', 'rgb(253,154,0)');
};

export const onSvgUnhover = (ref, fill) => {
    if (!ref?.current) return;
    ref.current.setAttribute('fill', fill || 'rgb(65, 65, 65)');
};

export const buildSvgEvents = (ref, disabled, onClick, fill) => {
    const retVal = {};

    if (disabled) return retVal;

    if (typeof onClick === 'function') {
        retVal.onClick = onClick;
    }
    if (ref?.current !== null) {
        const onMouseOver = () => onSvgHover(ref);
        const onMouseOut = () => onSvgUnhover(ref, fill);
        retVal.onMouseOver = onMouseOver;
        retVal.onMouseOut = onMouseOut;
    }

    return retVal;
};
